<div #pageContainer class="w-full">
    <div class="bg-card shadow rounded-2xl p-5 m-4">
        <div class="text-2xl text-center font-medium tracking-tight leading-6 mb-8 truncate">
            Management of Change
        </div>

        <div role="tablist" class="tabs tabs-boxed w-2/4 mt-2 mb-4">
            <a role="tab" class="tab flex items-center justify-center gap-2"
                [ngClass]="{'primary-tab-active': router.url.includes('records')}" (click)="toggleMawop('records')">
                <span>Records</span>
                <mat-icon svgIcon="heroicons_outline:information-circle" [ngClass]="{'text-white': router.url.includes('records')}"
                    matTooltip='The records were pulled from MOC SharePoint application'></mat-icon>
            </a>
            <a role="tab" class="tab" [ngClass]="{'primary-tab-active': !router.url.includes('records')}"
                (click)="toggleMawop('application-tracking')">
                Application Tracking
            </a>
        </div>

        <router-outlet></router-outlet>
    </div>
</div>